/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-05-12 10:42:30
 */

 import * as Vue from 'vue-tsx-support';
 import { Component } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import _ from 'lodash';
 import { createBEM } from 'src/util/bem';
 import '../dataViewDetail.less';
 import StationSider from 'src/pages/stationDetail/component/stationSider';
 import DataViewDetailList from '../dataViewDetailList';
 import { MenuI } from 'src/pages/store/modules/layout';
 import MenuBtn from 'src/pages/layout/components/menuBtn';
 import DataAudit from '../../dataAudit/dataAudit';
 import { StationListDOI } from 'src/pages/stationList/api/stationListApi';
 import Bus, { Events } from 'src/util/bus';
 import DataComplete from '../../dataComplete/dataComplete';
 let bem = createBEM('data-view-detail');
 @Component({name: 'data-manage-data-view-detail'})
 export default class DataViewDetail extends Vue.Component<any> {
 
     mn = ''
     cn = ''
     mounter() {
         this.mn = this.$route.query.mn
     }
     stationChange(data: StationListDOI.RowDataI) {
         this.$router.replace({
             query: { mn: data.mn + '',productId: data.product_id+'', name: data.name, id: data.id+"",cn: this.cn}
         })
     }
     created() {
         this.cn = this.$route.query.cn
         Bus.$on(Events.StationChange, this.stationChange); 
     }
 
     beforeDestroy() {
         Bus.$off(Events.StationChange, this.stationChange);
     }
     render(h) {
         return (
             <div class={bem()}>
                 <div class={bem('side')}>
                     <StationSider mn={this.$route.query.mn} />
                 </div>
                 <div class={bem('content')}>
                     <DataComplete></DataComplete>
                 </div>
             </div>
         );
     }
 }
 